import { render, staticRenderFns } from "./maincharts.vue?vue&type=template&id=6cfff287&scoped=true&"
import script from "./maincharts.vue?vue&type=script&lang=js&"
export * from "./maincharts.vue?vue&type=script&lang=js&"
import style0 from "./maincharts.vue?vue&type=style&index=0&id=6cfff287&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfff287",
  null
  
)

export default component.exports